class NotificationSoundManager {

  constructor() {
    this.lastPlayedAt = 0;
    this.minInterval = 1500;
    this.userHasInteracted = false;

    document.addEventListener("click", () => {
      this.userHasInteracted = true;
    }, { once: true });
  }

  play(src, volume = 0.6) {

    const now = Date.now();

    // evitar spam
    if (now - this.lastPlayedAt < this.minInterval) {
      return;
    }

    this.lastPlayedAt = now;

    try {
      const audio = new Audio(src);
      audio.volume = volume;

      if (this.userHasInteracted) {
        audio.play().catch(() => {});
      } else {
        document.addEventListener(
          "click",
          () => audio.play().catch(() => {}),
          { once: true }
        );
      }

    } catch (e) {
      console.error("Notification sound error", e);
    }
  }
}

export const notificationSoundManager = new NotificationSoundManager();